export const GET_LIST_TONGQUATCUAHANG = "GET_LIST_TONGQUATCUAHANG";
export const GET_LIST_TONGQUATCUAHANG_SUCCESS =
  "GET_LIST_TONGQUATCUAHANG_SUCCESS";
export const GET_LIST_TONGQUATCUAHANG_FAILURE =
  "GET_LIST_TONGQUATCUAHANG_FAILURE";
